const leisureRides = (state = [], action) => {

	let leisureRides;

	switch (action.type) {

		case 'PUT_RIDES':

			leisureRides = action.payload.rides;

			return { ...leisureRides };

		case 'CLEAR_RIDES':

			leisureRides = {};

			return { ...leisureRides };

		default:

			return state;
	}
}

export default leisureRides;



// WEBPACK FOOTER //
// ./src/reducers/leisureRides.js